import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useContext } from "react";
import { Fragment } from "react";
import {
  Button,
  Alert,
  Card,
  CardBody,
  CardFooter,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import {
  findMyPaysAsProperty,
  PaymentProperty,
} from "../../helpers/api/finance";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import FalconCardHeader from "../common/FalconCardHeader";
import Calendar from "../common/Calendar";
import PageHeader from "../common/PageHeader";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import FullPagination from "../common/pagination/FullPagination";
import { useSelector } from "react-redux";
import withRedirect from "../../helpers/hoc/withRedirect";
import Filter from "../common/Filter";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { isIterableArray } from "../../helpers/utils";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import SupportLink from "../root/support/components/SupportLink";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";
import VoidPaymentModal from "./VoidPaymentModal";

const Payments = () => {
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { role } = useSelector((state) => state.auth.user);
  const history = useHistory();
  const { property, id } = useParams();
  const { baseCurrency } = useContext(CurrencyContext);
  // HO-FIX: esta pantalla se abre igual desde Finanzas y desde
  // Contabilidad, asi que los links internos siguen el modulo actual.
  const moduleBase = useModuleBase();
  const [params, setParams] = useState({
    status: null,
    condominiumId: selectedCondominium,
    property_id: property,
    start_date: null,
    end_date: null,
  });

  const filter_options = [
    { value: 0, displayName: "Todos", disabled: false },
    { value: "pending", displayName: "Pendientes", disabled: false },
    { value: "approved", displayName: "Aprobados", disabled: false },
    { value: "refused", displayName: "Cancelados", disabled: false },
    { value: "voided", displayName: "Anulados", disabled: false },
  ];

  const {
    data,
    error,
    isLoading,
    meta,
    mutate,
    handler: { goToPage, nextPage, perPage, previousPage },
  } = useSWRFetchPagination(PaymentProperty, params);
  const [voidTarget, setVoidTarget] = useState(null);

  const months = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];


  return (
    <Fragment>
      <Card>
        <FalconCardHeader title="Pagos realizados">
          <Row>
            <Col xs={12}>
              <Filter
                keyField="status"
                options={filter_options}
                selectType={setParams}
                dateFilter={true}
              />
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody className="fs--1 pt-0">
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            {data.length > 0 ? (
              data.map((payment, i) => (
                <Or key={i} value={true}>
                  <Row
                    className={
                      payment?.status === "pending"
                        ? "border-top py-3"
                        : payment?.status === "canceled"
                        ? "alert-danger border-top py-3"
                        : payment?.status === "refused"
                        ? "alert-danger border-top py-3"
                        : payment?.status === "voided"
                        ? "alert-secondary border-top py-3"
                        : "alert-success border-top py-3"
                    }
                  >
                    <Col>
                      <Row>
                        <Col>
                          <Row>
                            <Col xs={9} className="d-flex align-items-center">
                              <Media>
                                <Calendar
                                  month={
                                    months[
                                      new Date(payment?.created_at).getMonth()
                                    ]
                                  }
                                  day={new Date(payment?.created_at).getDate()}
                                />
                                <Media
                                  body
                                  className="position-relative pl-3 align-self-center"
                                >
                                  <p className="mb-0">
                                    Abono del propietario{" "}
                                    {payment?.property?.user?.data?.firstname}{" "}
                                    {payment?.property?.user?.data?.lastname}
                                  </p>
                                  <p className="fs--1 mb-0 font-weight-bolder">
                                    {payment?.status === "pending"
                                      ? "Pendiente"
                                      : payment?.status === "canceled"
                                      ? "Cancelado por propietario"
                                      : payment?.status === "refused"
                                      ? "Pago rechazado"
                                      : payment?.status === "voided"
                                      ? "Anulado"
                                      : "Aprobado"}
                                  </p>
                                  {payment?.control_number && (
                                    <p className="fs--1 mb-0 text-600">
                                      N° de control {payment.control_number}
                                    </p>
                                  )}
                                </Media>
                              </Media>
                            </Col>
                            <Col
                              xs={3}
                              className=" d-flex align-items-center justify-content-end"
                            >
                              <Media>
                                <Media
                                  body
                                  className="border-left position-relative pl-3"
                                >
                                  <p className="mb-0 font-weight-bolder">
                                    Monto
                                  </p>
                                  <p className="fs--1 mb-0 text-600">
                                    <NumberFormat
                                      displayType="text"
                                      value={payment?.amount}
                                      thousandSeparator
                                      decimalScale={2}
                                      fixedDecimalScale
                                      prefix={`${baseCurrency.symbol} `}
                                    />
                                  </p>
                                </Media>
                              </Media>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          xs="auto"
                          className="d-sm-flex align-items-center justify-content-end"
                        >
                          <UncontrolledDropdown
                            direction="left"
                            className="d-inline-block ml-2"
                          >
                            <DropdownToggle color="falcon-default" size="sm">
                              <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <Link
                                pay={data}
                                to={`/dashboard/${moduleBase}/${selectedCondominium}/payments/property/${payment?.advance_payment_id}`}
                              >
                                <DropdownItem>Ver detalles</DropdownItem>
                              </Link>
                              {role === "manager" &&
                                payment?.status === "approved" && (
                                  <DropdownItem
                                    className="text-danger"
                                    onClick={() =>
                                      setVoidTarget(payment.advance_payment_id)
                                    }
                                  >
                                    Anular saldo a favor
                                  </DropdownItem>
                                )}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Or>
              ))
            ) : (
              <Or value={false}>
                <Message
                  value={false}
                  color={"info"}
                  className="p-3"
                  align="left"
                  icon={faInfoCircle}
                >
                  <>Aún no hay abonos para mostrar</>
                </Message>
              </Or>
            )}
          </PreloadState>
        </CardBody>
        <CardFooter>
          {isIterableArray(data) && (
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"pagos"}
              perPage={perPage}
            />
          )}
        </CardFooter>
      </Card>
      <VoidPaymentModal
        isOpen={voidTarget !== null}
        toggle={() => setVoidTarget(null)}
        kind="advance"
        paymentId={voidTarget}
        onVoided={() => mutate()}
      />
    </Fragment>
  );
};

export default withRedirect(Payments);
